import { css, CSSResult, unsafeCSS } from 'lit';
import { designTokenFactory } from '../../utils/design-tokens.js';

const dt = designTokenFactory('cardlint');
const dt$ = (tokenPath: string, state?: string): CSSResult => unsafeCSS(`var(${dt(tokenPath, state)})`);

const header = css`
  header {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${dt$('gap')};
  }

  header label {
    position: relative;
  }

  header input {
    position: absolute;
    width: 0;
    height: 0;
    top: 0;
    left: 0;
    clip: rect(0, 0, 0, 0);
  }
`;

export default [header];
